
import React, { useState,useContext } from 'react';
import {useNavigate} from 'react-router-dom';
import {UserLogin,UserForgetPassword} from '../../../services/routes.services';
import AuthContext from '../../../store/auth-context';
import LoginStyle from '../../Styles/Login.module.css';
import ButtonStyle from '../../Styles/Button.module.css';
import FontStyle from "../../Styles/FontStyle.module.css";
import CommonStyle from "../../Styles/Common.module.css";
import { Link } from 'react-router-dom';
import {IMAGE_BASE_URL} from '../../../constants';
import {
  getFacebookLogin,
  getGooglelogin,
} from "../../../services/routes.services";
import { IconBase } from 'react-icons';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

const LoginPopup = ({ url,pageName,onClose }) => {
  //console.log("pageName",pageName)
  const [errorMsg, setErrorMsg] = useState('');
  const [forgotMsg, setForgotMsg] = useState(false);

  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [type, setType] = useState('password');
  const [errors, setErrors] = useState({});
  const [megErrors, setMegErrors] = useState();
  const [icon, setIcon] = useState(AiOutlineEye);

  const handleToggle = () => {
    if (type==='password'){
      setIcon(AiOutlineEyeInvisible);
       setType('text')
    } else {
      setIcon(AiOutlineEye);
       setType('password')
    }
 }

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

const forgetTrouble =()=>{
  setForgotMsg(true);
}

  const validateForm = (data) => {
    const errors = {};
    // Add validation rules for each field
    if (!data.email) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = 'Invalid email format';
    }

    if (!data.password) {
      errors.password = 'Password is required';
    } else if (data.password.length < 8) {
      errors.password = 'Password must be at least 8 characters';
    }

    return errors;
  };
const handleForgetpassword=(event)=>{
  event.preventDefault();
 
        let errorsEemail=''
        if (!formData.email) {
          errorsEemail = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
          errorsEemail = 'Invalid email format';
        }
 
        setMegErrors(errorsEemail);
    if (Object.keys(errorsEemail).length === 0) {
      
      let loginReq = UserForgetPassword({"u_email": formData.email});
          loginReq.then((res) => {
            console.log('userdata===',res)
            if(res.data.success === true){
              setForgotMsg(false)
            }
            else{
             
              setMegErrors(res.data.message)
            }

        })
        .catch((error) => {
          setErrorMsg("Could not get logged in.. Error: " + error);
          return false;
        });
    }
}
  const handleLogin = (event) => {
    event.preventDefault();
    const validationErrors = validateForm(formData);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      
     

          let loginReq = UserLogin({"u_email": formData.email, "password": formData.password});
          loginReq.then((res) => {
            //console.log('userdata===',res.response)
            if(res.data.success === true){
              //alert(1);
              const userData = {
                  token: res.data.token,
                  u_token:res.data.data.token,
                  u_email: res.data.data.u_email,
                  u_name: res.data.data.u_name,
                  u_phone: res.data.data.u_phone,
                  u_image:  res.data.data.image?IMAGE_BASE_URL+'/user/'+res.data.data.image:require('../../../assest/images/avtarImg.png'),
                  organization:res.data.data.organization,
                  designation:res.data.data.designation,
                  lister:res.data.data.lister,
              }
              authCtx.login(userData);
              //alert(url);
              if(url==undefined || pageName==undefined){
                navigate('/my-account');
              }else{
                navigate('');
              }
              
              // if(pageName===undefined){
              //   navigate('/my-account');
              // }
            
             
              onClose();
            }else{
              setErrorMsg(res.data.message);
              return false;
            }
          })
          .catch((error) => {
            setErrorMsg("Could not get logged in.. Error: " + error);
            return false;
          });
    }
  };
const SignupRedirction=(url)=>{
  navigate(url);
  onClose();
}
  const responseFacebook = (response) => {
    getFacebookLogin()
      .then((res) => {
        //console.log(res.data.redirect_url);
        window.open(res.data.redirect_url, "_blank");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const responseGoogleSuccess = (res) => {
    getGooglelogin()
      .then((res) => {
        window.open(res.data.redirect_url, "_blank");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className={LoginStyle.loginBox}>
      <div className={LoginStyle.loginContainer}>
        <span className={LoginStyle.closeBox} onClick={onClose}><svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none"><path d="M23.6795 10.5306L10.0306 24.1795M10.0306 10.5306L23.6795 24.1795M32.2101 17.355C32.2101 25.8354 25.3354 32.7101 16.855 32.7101C8.37469 32.7101 1.5 25.8354 1.5 17.355C1.5 8.87469 8.37469 2 16.855 2C25.3354 2 32.2101 8.87469 32.2101 17.355Z" stroke="black" stroke-width="2.05917" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <h3>Login</h3>
        <div className={LoginStyle.loginStyle}>
          <div className={LoginStyle.loginImg}>
            <img src={require('../../../assest/images/loginImg.jpg')} alt='Login' />
          </div>
          {forgotMsg === false ?(
          <div className={LoginStyle.loginFomrStyle}>
            {errorMsg && <span>{errorMsg}</span>}
            <h4>Welcome</h4>
            <p>Enter your details to login</p>
            <div className={LoginStyle.inputFeild}>
              <img src={require('../../../assest/images/emailIcon.png')} className={LoginStyle.fieldIcon} />
              <input type="text" placeholder="Username" name='email' value={formData.email} onChange={handleChange}/>
              {errors.email && <span className={LoginStyle.errorMsg}>{errors.email}</span>}
            </div>
            <div className={LoginStyle.inputFeild}>
              <span className={LoginStyle.fieldIcon}><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M17.5554 10.2295H5.32955C4.36496 10.2295 3.58301 11.0114 3.58301 11.976V18.0889C3.58301 19.0535 4.36496 19.8355 5.32955 19.8355H17.5554C18.5199 19.8355 19.3019 19.0535 19.3019 18.0889V11.976C19.3019 11.0114 18.5199 10.2295 17.5554 10.2295Z" stroke="black" stroke-width="1.04793" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.07568 10.2296V6.73648C7.07568 5.57845 7.53571 4.46785 8.35456 3.64899C9.17341 2.83014 10.284 2.37012 11.442 2.37012C12.6001 2.37012 13.7107 2.83014 14.5295 3.64899C15.3484 4.46785 15.8084 5.57845 15.8084 6.73648V10.2296" stroke="black" stroke-width="1.04793" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
              <input type={type} name='password' placeholder="Password" value={formData.password} onChange={handleChange}/>
              <span className={LoginStyle.showPassword} onClick={handleToggle}>{icon}</span>
              {errors.password && <span className={LoginStyle.errorMsg}>{errors.password}</span>}
            </div>
            <button onClick={handleLogin} className={ButtonStyle.largeButton + ' ' + ButtonStyle.roundStyle + ' ' + ButtonStyle.orangeStyle}>Login</button>
            <a  onClick={forgetTrouble} title='Having trouble in sign in?'>Having trouble in sign in?</a>
          </div>):(<div className={LoginStyle.loginFomrStyle}>
            {errorMsg && <span>{errorMsg}</span>}
            <h4>Welcome</h4>
            <p>Enter your email to Recover Password</p>
            <div className={LoginStyle.inputFeild}>
              <img src={require('../../../assest/images/emailIcon.png')} className={LoginStyle.fieldIcon} />
              <input type="text" placeholder="Username" name='email' value={formData.email} onChange={handleChange}/>
              {megErrors &&<span className={LoginStyle.errorMsg}>{megErrors}</span>}
            </div>
           
            <button onClick={handleForgetpassword} className={ButtonStyle.largeButton + ' ' + ButtonStyle.roundStyle + ' ' + ButtonStyle.orangeStyle}>Send</button>
           
            </div>)
}
        </div>
        <div className={LoginStyle.signUpOption }>
            <h4><span>Or Sign in with</span></h4>
            <div className={LoginStyle.flexRow }>
              <button onClick={responseGoogleSuccess}><img src={require('../../../assest/images/gmailIcon.png')} /> Google</button>
              {/* <button onClick={responseGoogleSuccess}><img src={require('../../../assest/images/appleIcon.png')} /> Apple</button> */}
              <button onClick={responseFacebook}><img src={require('../../../assest/images/faceBookIcon.png')} /> Facebook</button>
            </div>
        </div>
        <div className={LoginStyle.signUpOption}>
          <p>Don`t have an account? <a onClick={()=>SignupRedirction('/sign-up')} className={ FontStyle.Axiforma800 + " " + FontStyle.BlackColor}>Register Now</a></p>
          <p>© Copyright 2023. Easyrecce. All Rights Reserved <a className={FontStyle.Axiforma800 + " " + FontStyle.BlackColor} onClick={()=>SignupRedirction('/privacy-policy')}>Privacy Policy</a></p>
        </div>
      </div>
    </div>
  );
};

export default LoginPopup;
